module.exports = __webpack_public_path__ + "img/Unova.baf2d8c7.png";